import { render } from "./DesignSamplesBlockWatch.vue?vue&type=template&id=035443bb"
import script from "./DesignSamplesBlockWatch.vue?vue&type=script&lang=js"
export * from "./DesignSamplesBlockWatch.vue?vue&type=script&lang=js"

import "./DesignSamplesBlockWatch.vue?vue&type=style&index=0&id=035443bb&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__